import { Log } from "../generic";

export enum StepToReturnEnum {
  STEP_5 = 5,
  STEP_6 = 6,
}
export interface CreateStep7Body {
  proceed_for_closure: boolean | null;
  step_to_return: StepToReturnEnum | null;
  verification_comment: string;
  draft: boolean;
}

export interface Step7Response extends CreateStep7Body, Log {
  cto_code: string;
  can_user_fill_step: boolean;
  eligible_users?: string[];
}
